import React from 'react';
import ErrorMsg from '../components/ErrorMsg';

const Reference = ({
  reference,
  index,
  number,
  onReference,
  onFocus,
  onBlur
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group col-2 mb-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "mb-1 fs-sm",
    htmlFor: "reference" + number + "-" + index
  }, "Premise ", number), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `form-control form-control-sm ${reference.error ? "is-invalid" : ""}`,
    id: "reference" + number + "-" + index,
    onChange: e => onReference(e.target.value),
    onBlur: e => onBlur(e.target.value),
    onFocus: e => onFocus(e.target.value),
    value: reference.input
  }), /*#__PURE__*/React.createElement(ErrorMsg, {
    error: reference.error
  }));
};

export default Reference;